<template>
    <div class="category_title_menu">
      <van-tabs v-model:active="active" scrollspy sticky color="#666">
        <van-tab
          v-for="(item, index) in CollectionList.CategoryModel"
          :key="index"
        >
          <template #title> {{ item.Name }} </template>
          <div class="category_content_itemtitle">
            {{ item.Name }}
          </div>
          <div
            class="product_content"
            v-for="(product, indexs) in item.Products"
            :key="indexs"
          >
            <div class="product_item">
              <TakeOutProductCollection
                :ProductItem="product"
                :CollectionId="CollectionId"
                :OrderId="OrderId"
                :CartId="CartId"
              />
            </div>
          </div>
        </van-tab>
      </van-tabs>

      <br />
      <br />
      <br />
      <br />
      <br />
    </div>
    <TakeOutTabbar :active="1" />
  </template>
<script >
import axios from "../../commons/AxiosMethod.js"
import TakeOutProductCollection from "../../components/TakeOuts/TakeOutProductCollection.vue"
import TakeOutTabbar from "../../components/tabbars/TakeOutTabbar.vue"
import { showToast } from "vant"
import { Collapse, CollapseItem, Tab, Tabs } from "vant"
export default {
  data () {
    return {
      index: 0,
      clientWidth: document.body.clientWidth,
      clientHeight: document.documentElement.clientHeight,

      active: "",
      CollectionList: [], // 合集列表
      CollectionOpt: {}, // 当前分类

      CollectionId: "", // 合集ID
      OrderId: "", // 订单ID
      CartId: "" // 购物车ID
    }
  },
  name: "App",
  mounted () {
    this.CollectionId = this.$route.query.collectionId
    this.OrderId = this.$route.query.orderId
    this.CartId = this.$route.query.cartId
    this.TableId = localStorage.getItem("Cache-TableId")
    this.GetCollections()
  },
  components: {
    TakeOutProductCollection,
    TakeOutTabbar
  },
  methods: {
    // 获取合集
    GetCollections () {
      axios.apiMethod(
        "/shoppings/Collection/GetCollectionCategory",
        "get",
        {
          Id: this.CollectionId
        },
        (result) => {
          this.CollectionList = result.Data
        }
      )
    },
    // 新增合集小项
    AddCollection (item) {
      axios.apiMethod(
        "/Store/StoreOrder/AddCollection",
        "get",
        { Id: item.Id, CartItemId: this.CartId, TableId: this.TableId, Count: 1 },
        (result) => {
          if (result.Data.IsSuccess) {

          } showToast(result.Data.Msg)
        }
      )
    }
  }
}
</script>
  <style lang="scss" scoped>
  .category_title_menu {
    width: 100%;
    background-color: #fff;
    top: 0px;
    z-index: 9090000;
    border-bottom: 1px solid #eee;
  }

  .product_content {
    width: calc(100% - 20px);
    margin: 0 auto;
    padding: 5px !important;
    border-radius: 5px;
    .product_item {
      width: calc(100% - 20px);
      margin: 0 auto;
      margin-top: 10px;
    }
  }
  .category_content_itemtitle {
    font-size: 12pt;
    font-weight: 700;
    font-size: 14pt;
    padding: 10px 20px;
  }
  </style>
